import { MobileSegmentInfoProps } from '../../types';
import { Props as MobileSegmentFlatProps } from './MobileSegmentFlat';
import { useMobileSegmentInfo } from '../../hooks';
import { usePagination } from '@shared/ui';
import { getTransferInfo } from '../../utils';
import i18n from 'i18next';

interface AircraftInfo {
	imageUrl: string;
	flightNumber: string;
	aircraftName: string;
	id: string;
}

export type UseMobileSegmentFlatInfo = (
	componentProps: MobileSegmentInfoProps & MobileSegmentFlatProps
) => ReturnType<typeof useMobileSegmentInfo> &
	ReturnType<typeof usePagination> & {
		aircrafts: AircraftInfo[];
		transferInfo: ReturnType<typeof getTransferInfo>;
	};

export const useMobileSegmentFlatInfo: UseMobileSegmentFlatInfo = componentProps => {
	const { showAirplaneInfo } = componentProps;

	let flightInfo: AircraftInfo[];

	if (showAirplaneInfo) {
		flightInfo = componentProps.segments.map(segment => ({
			aircraftName: segment.segment.aircraft?.name,
			flightNumber: `${segment.segment.marketingAirline.iata}-${segment.segment.flightNumber}`,
			imageUrl: segment.segment.aircraft?.icon,
			id: segment.segment.aircraft?.id
		}));
	}

	const mobileSegmentInfo = useMobileSegmentInfo(componentProps);
	const pagination = usePagination(0);
	const transferInfo = getTransferInfo(componentProps.segments);

	const transferString = transferInfo.transfersCount
		? `${transferInfo.transfersCount} ${i18n.t('MobileSegmentInfo:stop')}: ${transferInfo.iata.join(', ')}`
		: i18n.t('MobileSegmentInfo:Nonstop');

	return {
		...mobileSegmentInfo,
		...pagination,
		aircrafts: flightInfo ?? [],
		transferInfo: getTransferInfo(componentProps.segments),
		transferString
	};
};
